module.exports = __webpack_public_path__ + "static/media/ricardo-perez-phone.a3679e2d.svg";